// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const IdentityProviderType = {
  Rana: "rana",
  Azure: "azure",
  Clearly: "clearly",
} as const;
export type IdentityProviderType = (typeof IdentityProviderType)[keyof typeof IdentityProviderType];

export function instanceOfIdentityProviderType(value: any): boolean {
  for (const key in IdentityProviderType) {
    if (Object.prototype.hasOwnProperty.call(IdentityProviderType, key)) {
      if (IdentityProviderType[key as keyof typeof IdentityProviderType] === value) {
        return true;
      }
    }
  }
  return false;
}

export function IdentityProviderTypeFromJSON(json: any): IdentityProviderType {
  return IdentityProviderTypeFromJSONTyped(json, false);
}

export function IdentityProviderTypeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): IdentityProviderType {
  return json as IdentityProviderType;
}

export function IdentityProviderTypeToJSON(value?: IdentityProviderType | null): any {
  return value as any;
}

export function IdentityProviderTypeToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean
): IdentityProviderType {
  return value as IdentityProviderType;
}
